import React, { JSX } from "react";
import { useMatches, useParams } from "react-router";
import { RouteUtils } from "utilities/route-utils";
import { Anchor } from "../../../typography/anchors/anchor/anchor";
import { TranslatedCopy } from "utilities/interfaces/culture-resources";
import { t } from "utilities/localization/t";
import "./provider-detail-sidebar.scss";

// -------------------------------------------------------------------------------------------------
// #region Interfaces
// -------------------------------------------------------------------------------------------------

export interface ProviderDetailSidebarProps {
    navItems: ProviderDetailSidebarNavItem[];
}

export interface ProviderDetailSidebarNavItem {
    path: string;
    text: TranslatedCopy;
}

// #endregion Interfaces

// -------------------------------------------------------------------------------------------------
// #region Constants
// -------------------------------------------------------------------------------------------------

const CSS_CLASS_NAME = "provider-detail-sidebar";

// #endregion Constants

// -------------------------------------------------------------------------------------------------
// #region Component
// -------------------------------------------------------------------------------------------------

const ProviderDetailSidebar: React.FC<ProviderDetailSidebarProps> = ({ navItems }): JSX.Element => {
    const routeParams = useParams();
    const providerId = routeParams.id;

    const matches: any[] = useMatches();

    const findPathMatch = (path: string): boolean => {
        const match = matches.find((match) =>
            match.pathname?.toLowerCase().startsWith(path.toLowerCase())
        );
        return match != null;
    };

    return (
        <nav className={CSS_CLASS_NAME} aria-label={t("sidebar")}>
            {navItems.map((navItem) => (
                <Anchor
                    key={`nav-item-${navItem.text.replace(" ", "-")}`}
                    path={RouteUtils.replacePathParams(navItem.path, { id: providerId })}
                    text={t(navItem.text)}
                    cssClassName={
                        findPathMatch(
                            RouteUtils.replacePathParams(navItem.path, { id: providerId })
                        )
                            ? "-selected"
                            : ""
                    }
                />
            ))}
        </nav>
    );
};

// #endregion Component

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { ProviderDetailSidebar };

// #endregion Exports
